import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { DomainRichPlacementKWordsConfigurationDTO } from '../types/domainRichPlacementKWordsConfigurationDTO'

type Props = {
  ability: Ability
}

export const DOMAIN_RICH_PLACEMENT_K_WORDS_CONFIGURATION_FRAGMENT = ({
  ability,
}: Props): TypedDocumentNode<DomainRichPlacementKWordsConfigurationDTO> => gql`
  fragment DomainRichPlacementKWordsConfigurationFragment on DomainRichPlacementKwordsConfiguration {
    ${permitFields<DomainRichPlacementKWordsConfigurationDTO>({
      availability: ability.can('read', 'DomainRichPlacementsFeature-kWordsEmployeeSettings'),
      kwordsSiteId: ability.can('read', 'DomainRichPlacementsFeature-kWordsEmployeeSettings'),
      overrideWorkspaceDefaultsEnabled: ability.can(
        'read',
        'DomainRichPlacementsFeature-kWordsEmployeeSettings',
      ),
    })}
    customVariableName
    customVariableTriggerEnabled
    customVariableValue
    enabled
    matchType
    path
    pathTriggerEnabled
  }
`
